import { useMemo } from 'react'
import { useExperimentContext } from '@/experimentation'
import type { Holiday } from '@/views/TicketCheckoutViews/ShowtimesView/components/HolidayDates/holidayConstants'
import { HOLIDAYS } from '@/views/TicketCheckoutViews/ShowtimesView/components/HolidayDates/holidayConstants'

interface UseHolidayReturn {
  checkHoliday: (date: Date) => Holiday | null
  getAllHolidays: () => Record<string, Holiday>
}

const holidaysWithAllHonukkahDays: Record<string, Holiday> = {
  '04-13': { name: 'Palm', longName: 'Palm Sunday', color: '#A9CB54' },
  '04-18': { name: 'Good', longName: 'Good Friday', color: '#4DA0CC' },
  '04-20': { name: 'Easter', longName: 'Easter', color: '#B57FDE' },
  '12-14': { name: 'Hanukkah', longName: 'Hanukkah', color: '#4DA0CC' },
  '12-18': { name: 'Hanukkah', longName: 'Hanukkah', color: '#4DA0CC' },
  '12-19': { name: 'Hanukkah', longName: 'Hanukkah', color: '#4DA0CC' },
  '12-20': { name: 'Hanukkah', longName: 'Hanukkah', color: '#4DA0CC' },
  '12-21': { name: 'Hanukkah', longName: 'Hanukkah', color: '#4DA0CC' },
  '12-22': { name: 'Hanukkah', longName: 'Hanukkah', color: '#4DA0CC' },
  '12-24': { name: 'Christmas Eve', longName: 'Christmas Eve', color: '#8AA643' },
  '12-25': { name: 'Christmas Day', longName: 'Christmas Day', color: '#C86666' },
  '12-31': { name: "New Year's Eve", longName: "New Year's Eve", color: '#DCAE6F' },
  '01-01': { name: "New Year's Day", longName: "New Year's Day", color: '#B57FDE' },
}

export function useHoliday(): UseHolidayReturn {
  const { getFeatureValue, ready } = useExperimentContext()

  return useMemo(() => {
    const checkHoliday = (date: Date): Holiday | null => {
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const monthDay = `${month}-${day}`

      return getAllHolidays()?.[monthDay] ?? null
    }

    const getAllHolidays = (): Record<string, Holiday> => {
      if (ready && getFeatureValue('full-honukkah-calendar', 'off') === 'all days') {
        return holidaysWithAllHonukkahDays
      }

      return HOLIDAYS
    }

    return {
      checkHoliday,
      getAllHolidays,
    }
  }, [getFeatureValue, ready])
}
